// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__xoVhU","text":"Loader_text__RCAot","loaderAlertWrapper":"Loader_loaderAlertWrapper__BMBf0"};